import React, {useState, useRef, createRef} from 'react';
import {Table} from 'rsuite';
import {Form, Schema, SelectPicker, FormControl, Button} from "rsuite";
import Icon from "rsuite/es/Icon";
import BaseTable from "../../components/base/BaseTable";


const {Column, HeaderCell, Cell} = Table;

export default ({defaultFilter, addItem, update, ...props}) => {
    const form = useRef(null);

    const formControlNames = ["wz_key", "de_key", "sde_key", "sp_key", "account_id"];

    const [fields, setFields] = useState({});
    const [hasRequiredException, setRequiredException] = useState(false);

    const {StringType, NumberType} = Schema.Types;
    const formModel = Schema.Model({
        wz_key: NumberType(),
        de_key: NumberType(),
        sde_key: NumberType(),
        account_id: StringType()
    });

    const formControlItems = [
        <FormControl placement="autoVerticalStart" errorPlacement="topEnd" className="tableFilters_field" name="wz_key" accepter={SelectPicker} data={props.worldzoneList} placeholder="Zone" valueKey="wz_key" labelKey="name" type="text" />,
        <FormControl placement="autoVerticalStart" errorPlacement="topEnd" className="tableFilters_field" name="de_key" accepter={SelectPicker} data={props.destinationList} placeholder="Destination" valueKey="de_key" labelKey="name" type="text" />,
        <FormControl placement="autoVerticalStart" errorPlacement="topEnd" className="tableFilters_field" name="sde_key" accepter={SelectPicker} data={props.subdestinationList} placeholder="Subdestination" valueKey="sde_key" labelKey="name" type="text" />,
        <FormControl placement="autoVerticalStart" errorPlacement="topEnd" className="tableFilters_field" name="sp_key" accepter={SelectPicker} data={props.servicePlanList} placeholder="Service plan" valueKey="sp_key" labelKey="name" type="text" />,
        <FormControl placement="autoVerticalStart" errorPlacement="topEnd" className="tableFilters_field" name="account_id" accepter={SelectPicker} data={props.accountList} placeholder="Account" valueKey="id" labelKey="name" type="text" />,
    ];

    const handleChange = (formValues) => {
        setFields(formValues);

        checkAtLeastOneException(formValues);
    };
    const checkAtLeastOneException = (values) => {
        setRequiredException(!!formControlNames.map(key => values[key]).filter(value => value).length);
    };
    const handleSubmit = (_, event) => {
        event.preventDefault();

        let validStatus = form.current.check();

        if (!validStatus)
            return;

        let formValues = form.current.getFormValue();
        let data = {...formValues, action: true};

        addItem(data).then(() => {
            update();
        });

    };

    const columns = formControlNames.map( key => {
        return {dataKey: key, label: ''}
    } );

    const tableColumnsElements = {};
    for (let i = 0; i < formControlNames.length; i++) {
        tableColumnsElements[formControlNames[i]] = formControlItems[i];
    }

    const columnsElements = formControlNames.map( (item) => {
        return (
            <Column flexGrow>
                <HeaderCell></HeaderCell>
                <Cell dataKey={item}/>
            </Column>
        )
    } );

    return(
        <>
            <Form
                onSubmit={handleSubmit}
                ref={form}
                model={formModel}
                onChange={handleChange}
                // formDefaultValue={fields}
                formValue={fields}
                style={{margin: '0px', width: '100%'}}
            >

                <BaseTable
                    data={[tableColumnsElements]}
                    loading={false}
                    columns={columns}
                    headerHeight={0}
                    autoHeight
                    rowHeight={46}
                    className="tableFilters tableFilters__form"
                >
                    {columnsElements}
                    <Column width={hasRequiredException ? 164 : 64}>
                        <HeaderCell></HeaderCell>
                        <Cell>
                            {() => (
                                <Button disabled={!hasRequiredException} className="tableFilters_submit" color="green" type="submit">
                                    <Icon icon="plus"/>
                                </Button>
                            )}
                        </Cell>
                    </Column>
                </BaseTable>

            </Form>
        </>
    )
};